/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButtonClose from 'DesignSystem/TysiaButtonClose/index'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/Apps/Content/App/AppAction/ActionQr/Content/CloseAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButtonClose
  viewPath={`${viewPath}/TysiaButtonClose`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../../../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../../../../No'))}
/>
{children}
</React.Fragment>)
}